import React, { useState, useEffect } from 'react';
import { Button, TextField, Typography, List, ListItem, ListItemText } from '@mui/material';
import lineaNegocioApi from '../../../api/lineaNegocioApi';
import EditDashboardDialog from './EditDashboardDialog'; // Importa el componente de edición

const LinkDashboard = ({ linea_negocio ,onClose}) => {
  const [formData, setFormData] = useState({
    nameDashboard: '',
    urlDashboard: ''
  });
  const [dashboards, setDashboards] = useState([]);
  const [openEditDialog, setOpenEditDialog] = useState(false); // Estado para controlar la apertura del diálogo de edición
  const [selectedDashboard, setSelectedDashboard] = useState(null); // Estado para almacenar el dashboard seleccionado para editar

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await lineaNegocioApi.createDashboard({
        name: formData.nameDashboard,
        linea_negocio: linea_negocio.id,
        url: formData.urlDashboard
      });
      await fetchDashboards();
      setFormData({
        nameDashboard: '',
        urlDashboard: ''
      });
      alert('¡Dashboard creado correctamente!');
    } catch (error) {
      console.error('Error al crear el dashboard:', error);
      alert('Error al crear el dashboard. Consulta la consola para obtener más detalles.');
    }
  };

  const handleEditClick = (dashboard) => {
    setSelectedDashboard(dashboard); // Almacena el dashboard seleccionado para editar
    setOpenEditDialog(true); // Abre el diálogo de edición
  };
  const handleDeleteClick = (dashboard) => {
    try {
      lineaNegocioApi.deteleDashboards(dashboard.id);
      alert('¡Eliminado Correctamente!');

      onClose()
      setOpenEditDialog(false);
    } catch (error) {
      console.error('Error al elimnar los dashboards:', error);
    }
  };

  
  const handleCloseEditDialog = () => {
    setOpenEditDialog(false); // Cierra el diálogo de edición
    setSelectedDashboard(null); // Limpia el dashboard seleccionado
  };

  const fetchDashboards = async () => {
    try {
      const dashboardsData = await lineaNegocioApi.getDashboards(linea_negocio.id);
      setDashboards(dashboardsData);
    } catch (error) {
      console.error('Error al obtener los dashboards:', error);
    }
  };

  useEffect(() => {
    fetchDashboards();
  }, []);

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Nombre referencial"
          variant="outlined"
          fullWidth
          name="nameDashboard"
          value={formData.nameDashboard}
          onChange={handleInputChange}
          required
        />
        <TextField
          label="URL del Panel de Control"
          variant="outlined"
          fullWidth
          name="urlDashboard"
          value={formData.urlDashboard}
          onChange={handleInputChange}
          required
        />
        <Button type="submit" variant="contained" color="primary" style={{ marginTop: '1rem' }}>
          Guardar
        </Button>
      </form>
      
      <Typography variant="h6" style={{ marginTop: '2rem' }}>Dashboards:</Typography>
      <List>
        {dashboards.map((dashboard) => (
          <div key={dashboard.id}>
            <ListItem>
              <ListItemText primary={dashboard.name} secondary={dashboard.url} />
              <Button onClick={() => handleEditClick(dashboard)}>Editar</Button>
              <Button onClick={() => handleDeleteClick(dashboard)}>Eliminar</Button>
            </ListItem>
            {selectedDashboard && selectedDashboard.id === dashboard.id && ( 
              <EditDashboardDialog
                open={openEditDialog}
                handleClose={handleCloseEditDialog}
                dashboard={selectedDashboard}
              />
            )}
          </div>
        ))}
      </List>
    </div>
  );
};

export default LinkDashboard;
